
<div class="main-container">
    <div class="close-btn-container" (click)="close()">
        <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon">
    </div>
    <div class="pest-pin-close-container">
        <div class="header-container-new-pest-pin">
            <span><img src="../../assets/icons/pest_pin.png" alt="New Pin Icon" class="new-pest-pin-header-icon"> </span>
            <h1 mat-dialog-title  class="new-pest-pin-header">{{ 'NEW-PIN-TYPE-DIALOG.PEST-TITLE' | translate }}</h1>
        </div>
    </div>

    <div class="pest-pin-info-container">

        <div class="pest-pin-container">
            <div class="pest-pin-headers">
                <p class="pest-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.DATE-TIME' | translate }}:</p>
                <p class="pest-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LATITUDE' | translate }}:</p>
                <p class="pest-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LONGITUDE' | translate }}:</p>
                <p class="pest-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FARM' | translate }}:</p>
                <p class="pest-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FIELD' | translate }}:</p>
                <p class="pest-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.CREATED-BY' | translate }}:</p>
            </div>

        </div>

        <div class="pest-pin-container">
            <ng-container>
                <p class="pest-pin-info-text">{{pinObj.date ? dayjs(pinObj.date).format(dateStringFormatting) : placeholder}}</p>
                <p class="pest-pin-info-text">{{pinObj.lat}}</p>
                <p class="pest-pin-info-text">{{pinObj.lng}}</p>
                <p class="pest-pin-info-text">{{pinObj.farm}}</p>
                <p class="pest-pin-info-text">{{pinObj.field}}</p>
                <p class="pest-pin-info-text">{{pinObj.creatingUser}}</p>
            </ng-container>

        </div>
    </div>

    <form [formGroup]="updatePinForm">
        <mat-form-field class="pest-pin-input" appearance="outline">
            <mat-label>{{'NEW-SAVE-PIN-DIALOG.PIN-NAME' | translate }}</mat-label>
            <input matInput formControlName="pinDescription">
            <mat-error *ngIf="updatePinForm.get('pinDescription').invalid"  class="error-notice">
                Required* - Pin Name
            </mat-error>
        </mat-form-field>

    <div class="pest-pin-btn-container">
        <div class="pest-pin-delete-btn-container">
            <button class="delete-pest-pin-btn" mat-flat-button type="button" (click)="openDeletePinDialog()">
                <div class="pest-pin-btn-content">
                    <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-pest-pin-btn-icon">
                    <span><p class="pest-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.DELETE-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>

        <!-- <div class="pest-pin-open-pest-btn-container">
            <button class="open-pest-pin-btn" mat-flat-button type="button" (click)="openConvertPinDialog()">
                <div class="pest-pin-btn-content">
                    <span><p class="pest-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.COVERT-PIN' | translate }}</p></span>
                </div>
            </button>
        </div> -->

        <div class="pest-pin-update-btn-container">
            <button class="update-pest-pin-btn" mat-flat-button type="button" (click)="updatePin()">
                <div class="pest-pin-btn-content">
                    <span><p class="pest-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.UPDATE-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>

    </div>

</form>

</div>



